"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChartYFieldScore = exports.getChartScore = void 0;
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const sum_1 = __importDefault(require("lodash/sum"));
const chartDefinitions_1 = require("./chartDefinitions");
function getChartScore(chart) {
    var _a, _b, _c;
    if (chart.errorMessage) {
        return -1; // negative score for charts with errors
    }
    let res = 0;
    res += chart.rowsAdded * 5;
    const ydefScores = chart.definition.ydefs.map(yField => getChartYFieldScore(chart, yField));
    const sorted = (0, sortBy_1.default)(ydefScores).reverse();
    res += (0, sum_1.default)(sorted.slice(0, chartDefinitions_1.ChartLimits.AUTODETECT_MEASURES_LIMIT));
    if (((_a = chart.groupSet) === null || _a === void 0 ? void 0 : _a.size) >= 2 && ((_b = chart.groupSet) === null || _b === void 0 ? void 0 : _b.size) <= 6) {
        res += 50; // bonus for nice grouping
    }
    if (((_c = chart.groupSet) === null || _c === void 0 ? void 0 : _c.size) == 1) {
        res -= 20; // penalty for single group
    }
    return res;
}
exports.getChartScore = getChartScore;
function getChartYFieldScore(chart, yField) {
    var _a, _b, _c;
    let res = 0;
    res += chart.validYRows[yField.field] * 5; // score for valid Y rows
    res += ((_b = (_a = chart.topDistinctValues[yField.field]) === null || _a === void 0 ? void 0 : _a.size) !== null && _b !== void 0 ? _b : 0) * 20; // score for distinct values in Y field
    res += chart.rowsAdded * 2; // base score for rows added
    res -= ((_c = chart.invalidYRows[yField.field]) !== null && _c !== void 0 ? _c : 0) * 50; // penalty for invalid Y rows
    return res;
}
exports.getChartYFieldScore = getChartYFieldScore;
